import { gsap, SplitText, ScrollTrigger } from "@gsap";
/**
 * Layout: Hero - Sponsor
 * Slug: hero_sponsor
 */

document.addEventListener('DOMContentLoaded', function() {
	gsap.registerPlugin(ScrollTrigger, SplitText);
    const layouts = document.querySelectorAll('.flex-layout.hero_sponsor-layout');

	layouts.forEach((layout) => {
		let split = SplitText.create(layout.querySelector(".title-col .pk-heading-text"), { type: "lines" });

		gsap.to(split.lines[1], {
			xPercent: 15,
			delay: 0.5
		});
	});
});
